module.exports = __webpack_public_path__ + "img/tn.d5713a62.svg";